import { has } from 'lodash';
import { PropModel } from '../prop.model';

export const MODEL_FAMILIES = ['haiku', 'sonnet', 'opus', 'fable'] as const;
export const APPLICATION_TYPES = ['claude-code'] as const;

export type ModelFamily = (typeof MODEL_FAMILIES)[number];
export type ApplicationType = (typeof APPLICATION_TYPES)[number];
export type ModelFamilyRerouteEntry = {
  privateModelId: string;
};

export class RerouteConfig extends PropModel {
  enabled?: boolean;
  modelFamilyReroutes?: Partial<Record<ModelFamily, ModelFamilyRerouteEntry>>;
  applicationType?: ApplicationType;

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof RerouteConfig, unknown>;

    if (has(data, 'enabled')) {
      this.enabled = !!data.enabled;
    }

    if (data.modelFamilyReroutes) {
      this.modelFamilyReroutes = data.modelFamilyReroutes as Partial<Record<ModelFamily, ModelFamilyRerouteEntry>>;
    }

    if (data.applicationType) {
      this.applicationType = data.applicationType as ApplicationType;
    }
  }
}

type ModelFamilyConfig = {
  label: string;
  recommendedModelId: string;
  modelFamilyOptions: ModelFamily[];
};

export const MODEL_FAMILY_LABELS: Record<ModelFamily, ModelFamilyConfig> = {
  haiku: {
    label: 'Claude Haiku',
    recommendedModelId: 'claude-haiku-4-5',
    modelFamilyOptions: ['haiku', 'sonnet', 'opus'],
  },
  sonnet: {
    label: 'Claude Sonnet',
    recommendedModelId: 'claude-sonnet-4-6',
    modelFamilyOptions: ['sonnet', 'opus'],
  },
  opus: {
    label: 'Claude Opus',
    recommendedModelId: 'claude-opus-4-8',
    modelFamilyOptions: ['opus', 'sonnet'],
  },
  fable: {
    label: 'Claude Fable',
    recommendedModelId: 'claude-opus-4-8',
    modelFamilyOptions: ['fable', 'opus', 'sonnet'],
  },
};

export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  'claude-code': 'Claude Code',
};
